import { ChangeEvent, memo, useCallback, useEffect, useRef, useState } from 'react'

import s from './HeaderBurget.module.scss'
import Image from 'next/image'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'
import { HeaderTheme } from './HeaderTheme'
import HeaderSelect from './HeaderSelect'

export const HeaderBurger = memo(
    ({
        burgerBg,
        setMobileActive,
        blueBg,
        searchActive,
        setSearchActive,
        mobileIconRef,
        isLightTheme,
        toggleTheme
    }: {
        burgerBg
        blueBg
        searchActive
        mobileIconRef
        isLightTheme
        toggleTheme
        setMobileActive
        setSearchActive
    }) => {
        const { t } = useTranslation()
        const [burgerOpen, setBurgerOpen] = useState(false)
        const burgerMenuRef = useRef<HTMLDivElement>(null)
        const [inputValue, setInputValue] = useState('')
        const inputRef = useRef<HTMLInputElement>(null)
        const onInputClear = useCallback(() => {
            setInputValue('')
        }, [setInputValue])
        useEffect(() => {
            const handleClickOutside = (event: MouseEvent) => {
                if (inputRef.current && !event.composedPath().includes(inputRef.current)) {
                    onInputClear()
                    setSearchActive(false)
                }
                if (mobileIconRef.current && !event.composedPath().includes(mobileIconRef.current)) {
                    setMobileActive(false)
                }
                if (
                    burgerMenuRef.current &&
                    closeBtnRef.current &&
                    !event.composedPath().includes(burgerMenuRef.current) &&
                    !event.composedPath().includes(closeBtnRef.current) &&
                    burgerOpen
                ) {
                    setBurgerOpen(false)
                }
            }

            document.body.addEventListener('click', handleClickOutside)
            return () => document.body.removeEventListener('click', handleClickOutside)
        }, [])
        const inputOpen = useCallback(() => {
            setSearchActive(true)
            inputRef.current?.focus()
        }, [setSearchActive])

        const onChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
            setInputValue(e.target.value)
        }

        const closeBtnRef = useRef<HTMLDivElement>(null)
        const preventDefaultScroll = useCallback(e => {
            e.preventDefault()
        }, [])
        const disableScroll = useCallback(() => {
            document.body.addEventListener('touchmove', preventDefaultScroll)
        }, [])

        const enableScroll = useCallback(() => {
            document.body.removeEventListener('touchmove', preventDefaultScroll)
        }, [])
        const toggleBurger = useCallback(() => {
            setBurgerOpen(!burgerOpen)

            if (!burgerOpen) {
                document.body.classList.add('no-scroll')
                document.querySelector('.news-details') &&
                    document.querySelector('.news-details').classList.add('background')
                disableScroll()
            } else {
                document.body.classList.remove('no-scroll')
                document.querySelector('.news-details') &&
                    document.querySelector('.news-details').classList.remove('background')
                enableScroll()
            }
        }, [burgerOpen, disableScroll, enableScroll])
        return (
            <>
                <div
                    style={burgerBg ? { background: burgerBg } : {}}
                    ref={burgerMenuRef}
                    className={`header__burger ${burgerOpen && 'header__burger_open'}`}
                >
                    <ul className='header__burger-list container'>
                        <li className='header__menu-item'>
                            <Link
                                className='header__menu-link'
                                onClick={toggleBurger}
                                href='/catalog'
                            >
                                {t('catalog')}
                            </Link>
                        </li>
                        <li className='header__menu-item'>
                            <Link
                                className='header__menu-link'
                                onClick={toggleBurger}
                                href='/b2b'
                            >
                                {t('aboutUs')}
                            </Link>
                        </li>
                        <li className='header__menu-item'>
                            <Link
                                className='header__menu-link'
                                onClick={toggleBurger}
                                href='/media'
                            >
                                {t('news')}
                            </Link>
                        </li>
                        <li className='header__menu-item'>
                            <Link
                                onClick={toggleBurger}
                                className='header__menu-link'
                                href='#contact'
                            >
                                {t('contacts')}
                            </Link>
                        </li>

                        <HeaderTheme
                            isLightTheme={isLightTheme}
                            toggleTheme={toggleTheme}
                        />

                        <HeaderSelect />
                        <li
                            onClick={inputOpen}
                            className='header__burger-search header__menu-item'
                        >
                            {!searchActive && (
                                <div className='header__burger-search-btn'>
                                    <svg
                                        className='header__burger-search-icon'
                                        width='20'
                                        height='20'
                                        viewBox='0 0 20 20'
                                        xmlns='http://www.w3.org/2000/svg'
                                    >
                                        <path
                                            fillRule='evenodd'
                                            clipRule='evenodd'
                                            d='M14.2251 9.01256C14.2251 11.8914 11.8914 14.2251 9.01256 14.2251C6.13374 14.2251 3.8 11.8914 3.8 9.01256C3.8 6.13374 6.13374 3.8 9.01256 3.8C11.8914 3.8 14.2251 6.13374 14.2251 9.01256ZM13.2763 14.5805C12.0948 15.4866 10.6166 16.0251 9.01256 16.0251C5.13963 16.0251 2 12.8855 2 9.01256C2 5.13963 5.13963 2 9.01256 2C12.8855 2 16.0251 5.13963 16.0251 9.01256C16.0251 10.6325 15.4758 12.1241 14.5534 13.3113L17.6133 16.5393C17.9552 16.9001 17.94 17.4697 17.5793 17.8117C17.2185 18.1536 16.6489 18.1384 16.3069 17.7777L13.2763 14.5805Z'
                                            fill='#7987AC'
                                        />
                                    </svg>
                                    <p>Поиск</p>
                                </div>
                            )}
                            <input
                                style={
                                    burgerBg ? (blueBg ? { background: 'transparent' } : { background: burgerBg }) : {}
                                }
                                value={inputValue}
                                onChange={onChangeInput}
                                className={searchActive ? 'header__menu-search_active' : 'header__menu-search'}
                                ref={inputRef}
                                type='text'
                                placeholder='Поиск'
                            />
                            {/* {searchActive && (
                                <Image
                                    className='header__input-close'
                                    width={20}
                                    height={20}
                                    src={inputClose}
                                    alt='close-button'
                                />
                            )} */}
                        </li>
                    </ul>
                    <div className='header__burger-info container'>
                        <div className='header__burger-contacts'>
                            <Link
                                className='header__menu-item'
                                href={`#`}
                            >
                                <p>info@megamix.ru</p>
                            </Link>
                            <a
                                className='header__menu-item'
                                href={`tel:+78442979797`}
                            >
                                <p>+7 844 297-97-97</p>
                            </a>
                        </div>
                        <div className='header__burger-media'>
                            <Link
                                target='_blank'
                                href='https://vk.com/megamix_official'
                                className='footer__media-social-link'
                            >
                                <svg
                                    width='44'
                                    height='44'
                                    viewBox='0 0 44 44'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                >
                                    <path
                                        d='M23.8498 33.2055C24.9534 33.2055 25.4046 32.5033 25.3919 31.6228C25.3357 28.307 26.6857 26.5219 29.1228 28.8484C31.8191 31.4222 32.3772 33.2055 35.6515 33.2055H41.45C42.9141 33.2055 43.4903 32.7558 43.4903 32.0501C43.4903 30.5573 40.9155 27.923 38.7338 25.9892C35.6787 23.2822 35.5356 23.2182 38.1666 19.9594C41.4301 15.9136 45.6992 10.7297 41.923 10.7297H34.7093C33.3104 10.7297 33.2089 11.4821 32.7106 12.603C30.9077 16.6626 27.4811 21.9209 26.1801 21.1166C24.8193 20.2777 25.4426 16.9549 25.5459 12.0166C25.5731 10.7124 25.5658 9.81815 23.4784 9.35459C22.3386 9.10378 21.2297 9 20.2004 9C16.0817 9 13.2404 10.6484 14.855 10.9355C17.7016 11.4423 17.428 17.3216 16.7648 19.8608C15.6088 24.282 11.2635 16.3599 9.45332 12.4144C9.01662 11.4666 8.88253 10.7297 7.32419 10.7297H1.42606C0.534547 10.7297 0 11.0065 0 11.6222C0 12.6635 5.36359 23.2459 10.4844 28.5215C15.4783 33.6674 20.4142 33.2055 23.8498 33.2055Z'
                                        fill='#83A3EB'
                                    />
                                </svg>
                            </Link>
                            <Link
                                target='_blank'
                                href='https://www.youtube.com/@megamix_official'
                                className='footer__media-social-link'
                            >
                                <svg
                                    width='44'
                                    height='44'
                                    viewBox='0 0 44 44'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                >
                                    <path
                                        d='M34.515 7.30079C28.5408 6.89892 15.2347 6.90055 9.26883 7.30079C2.80894 7.73533 2.04807 11.5808 2 21.7027C2.04807 31.8066 2.80231 35.6684 9.26883 36.1046C15.2364 36.5049 28.5408 36.5065 34.515 36.1046C40.9748 35.6701 41.7357 31.8246 41.7838 21.7027C41.7357 11.5988 40.9815 7.73696 34.515 7.30079ZM16.9189 28.2371V15.1683L30.1802 21.6913L16.9189 28.2371Z'
                                        fill='#83A3EB'
                                    />
                                </svg>
                            </Link>
                            <Link
                                target='_blank'
                                href='https://t.me/gk_megamix'
                                className='footer__media-social-link'
                            >
                                <svg
                                    width='39'
                                    height='39'
                                    viewBox='0 0 39 39'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                >
                                    <g clipPath='url(#clip0_3877_1430)'>
                                        <path
                                            fillRule='evenodd'
                                            clipRule='evenodd'
                                            d='M29.15 36.1181C29.6606 36.4796 30.3186 36.57 30.9053 36.348C31.4919 36.1245 31.9232 35.6234 32.0532 35.0161C33.4311 28.5406 36.7735 12.1504 38.0277 6.25996C38.1229 5.816 37.9643 5.35459 37.6155 5.05809C37.2666 4.76158 36.783 4.67596 36.3518 4.83611C29.7034 7.29694 9.22874 14.9791 0.860018 18.0757C0.328847 18.2724 -0.0168106 18.7829 0.000630831 19.3426C0.0196579 19.9039 0.397027 20.3907 0.940883 20.554C4.69396 21.6766 9.62038 23.2384 9.62038 23.2384C9.62038 23.2384 11.9226 30.1912 13.1229 33.7271C13.2736 34.171 13.6208 34.5199 14.079 34.6404C14.5357 34.7593 15.0241 34.634 15.365 34.3121C17.293 32.4919 20.2739 29.6775 20.2739 29.6775C20.2739 29.6775 25.9376 33.8301 29.15 36.1181ZM11.6927 22.36L14.3549 31.141L14.9464 25.5803C14.9464 25.5803 25.2321 16.3031 31.0955 11.0151C31.2668 10.8597 31.2906 10.5997 31.1479 10.4174C31.0068 10.235 30.7467 10.1922 30.5517 10.3159C23.7559 14.6556 11.6927 22.36 11.6927 22.36Z'
                                            fill='#83A3EB'
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id='clip0_3877_1430'>
                                            <rect
                                                width='38.0541'
                                                height='38.0541'
                                                fill='white'
                                            />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </Link>
                        </div>
                        <div className='header__burger-address'>
                            <p className='footer__address-text'>
                                Адрес: 400123, Волгоград, <br /> ул. Хрустальная, 107, оф.1
                            </p>
                            <p className='footer__address-text'>
                                © 2025 <br /> ООО «МЕГАМИКС»{' '}
                            </p>
                        </div>
                    </div>
                </div>
                <div
                    ref={closeBtnRef}
                    onClick={toggleBurger}
                    className='header__burger-icon'
                >
                    {burgerOpen ? (
                        <svg
                            width='20'
                            height='20'
                            viewBox='0 0 20 20'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M19.7071 10.7071C20.0976 10.3166 20.0976 9.68342 19.7071 9.29289L13.3431 2.92893C12.9526 2.53841 12.3195 2.53841 11.9289 2.92893C11.5384 3.31945 11.5384 3.95262 11.9289 4.34314L17.5858 10L11.9289 15.6569C11.5384 16.0474 11.5384 16.6805 11.9289 17.0711C12.3195 17.4616 12.9526 17.4616 13.3431 17.0711L19.7071 10.7071ZM1 9C0.447716 9 1.44847e-07 9.44771 0 10C-1.44847e-07 10.5523 0.447715 11 1 11L1 9ZM19 9L1 9L1 11L19 11L19 9Z'
                                fill='#919DBD'
                            />
                        </svg>
                    ) : (
                        <svg
                            width='20'
                            height='20'
                            viewBox='0 0 20 20'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <g opacity='0.8'>
                                <rect
                                    x='0.8'
                                    y='0.8'
                                    width='7.4'
                                    height='7.4'
                                    rx='2.2'
                                    stroke='#7987AC'
                                    strokeWidth='1.6'
                                />
                                <rect
                                    x='0.8'
                                    y='11.8'
                                    width='7.4'
                                    height='7.4'
                                    rx='2.2'
                                    stroke='#7987AC'
                                    strokeWidth='1.6'
                                />
                                <rect
                                    x='11.8'
                                    y='0.8'
                                    width='7.4'
                                    height='7.4'
                                    rx='2.2'
                                    stroke='#7987AC'
                                    strokeWidth='1.6'
                                />
                                <rect
                                    x='11.8'
                                    y='11.8'
                                    width='7.4'
                                    height='7.4'
                                    rx='2.2'
                                    stroke='#7987AC'
                                    strokeWidth='1.6'
                                />
                            </g>
                        </svg>
                    )}
                </div>
            </>
        )
    }
)
